<template>
  <cTable
    ref="table"
    :fields="fields"
    :modals="modals"
    :header="header"
    :methods="methods"
  >
  </cTable>
</template>

<script>
import {
  getPicking,
  postCnbNum,
  del,
  boundTime,
  addTrace,
  handlePacking,
  exportPacking,
  exportPackingZip,
  exportCustomsData,
  exportOutboundData,
  updateOrderInfo,
  getDownPort,
  getLog,
  createTransport,
  batchRemarks
} from "@/api/packing/packing";
import { getWarehouse } from "@/api/storage/warehouse";
import { getTransportAgent, addZhongGang } from "@/api/tracker/air";
import { getUser } from "@/api/user/internal";
import cTable from "@/base/common/index";
import getLodop from "@/utils/lodop";
import {fetchOperationLog} from "@/api/tracker/params";

export default {
  name: "packingList",
  components: {
    cTable
  },
  async mounted() {
    let hkAgentList = (await getTransportAgent({ type: 4 })).data.payload;
    let userList = (await getUser()).data.payload.rows;
    let selectData = await this.$sel.getData([
      "OMS_DISEMBARKATION_METHOD",
      "SHIPPING_WAREHOUSE"
    ]);
    this.header.searchs.forEach(item => {
      if (item.key === "warehouseId")
        item.options = selectData["SHIPPING_WAREHOUSE"];
      if (item.key === "operator") item.options = userList;
    });
    this.modals.update.fields.forEach(item => {
      if (item.key === "hk_agent") item.options = hkAgentList;
      if (item.key === "lower_port")
        item.options = selectData["OMS_DISEMBARKATION_METHOD"];
    });
  },
  data() {
    let timeType = [
        { label: "createTime", value: "create_time" },
        { label: "outbound_time", value: "outbound_time" },
        { label: "toHKtime", value: "inbound_time" }
      ],
      keyType = [
        { label: "packing_number", value: 1 },
        { label: "bagNum", value: 2 },
        { label: "orderNum", value: 3 },
        { label: "agentName", value: 4 },
        { label: "mawb", value: 5 }
      ],
      trackList = {
        90: { label: "CustomsReleased", value: 90 },
        91: { label: "CustomsInspection", value: 91 },
        92: { label: "FormalClearance", value: 92 },
        93: { label: "CustomsHold", value: 93 }
      },
      typeList = {
        in: { label: "MoveIn", value: "in" },
        out: { label: "MoveOut", value: "out" }
      },
      globalUrl = this.$globalUrl;
    return {
      methods: {
        list: getPicking,
        exportOutboundData,
        postCnbNum,
        del,
        boundTime,
        addTrace,
        handlePacking,
        exportPacking,
        exportPackingZip,
        exportCustomsData,
        addZhongGang,
        updateOrderInfo,
        getLog,
        createTransport,
        batchRemarks
        // confirmError
      },
      modals: {
        operationModal: {
          config: {
            modalBind: {
              width: 720,
              transfer: true,
              draggable: true,
              sticky: true,
              "reset-drag-position": true,
              styles: {
                top: "30px",
              },
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            formBind: {},
          },
          footer: {
            show: () => false,
          },
          table: {
            config: {
              height: 750,
            },
            footer: {
              show: () => false,
            },
            fields: [
              {
                name: () => this.$t("操作时间"),
                key: "operation_time",
                minWidth: 180,
              },
              {
                name: () => this.$t("操作人"),
                key: "operator",
                minWidth: 120,
              },
              {
                name: () => this.$t("操作说明"),
                key: "remarks",
                minWidth: 400,
              },

            ],
          },
        },
        print3: {
          type: "add",
          methods: {
            ok({ row, close }) {
              let LODOP = getLodop(this);
              LODOP.PRINT_INIT("打印任务名"); //首先一个初始化语句
              LODOP.SET_PRINT_PAGESIZE(0, "90mm", "60mm", ""); //规定纸张大小；使用A4纸
              LODOP.SET_PRINT_STYLE("FontSize", 55);
              LODOP.SET_PRINT_STYLE("FontName", "Impact");
              LODOP.SET_PRINT_STYLE("Bold", 1);
              Array(~~row.number)
                .fill(1)
                .forEach((_, i) => {
                  LODOP.ADD_PRINT_TEXT(
                    "17mm",
                    "2mm",
                    "90mm",
                    "50mm",
                    "OVERPACK"
                  );
                  LODOP.NEWPAGE();
                });
              LODOP.PREVIEW();
            }
          },
          config: {
            title: this.$tz(""),
            modalBind: {
              width: 500
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              number: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur"
                }
              ]
            }
          },
          grid: [{ number: 24 }],
          fields: [
            {
              name: () => this.$tz("数量"),
              key: "number",
              component: "Input",
              placeholder: () => this.$tz("数量")
            }
          ]
        },
        print2: {
          type: "add",
          methods: {
            ok({ row, close }) {
              console.log(
                row,
                this.$page.format.customTime(new Date(), "YYMMDD")
              );
              let LODOP = getLodop(this);
              LODOP.PRINT_INIT("打印任务名"); //首先一个初始化语句
              LODOP.SET_PRINT_PAGESIZE(2, "100mm", "150mm", ""); //规定纸张大小；使用A4纸
              LODOP.SET_PRINT_STYLE("FontSize", 30);
              Array(~~row.number)
                .fill(1)
                .forEach((_, i) => {
                  console.log(i);
                  LODOP.ADD_PRINT_TEXT(
                    "20mm",
                    "20mm",
                    "150mm",
                    "20mm",
                    "VN" +
                      row.destination +
                      this.$page.format.customTime(new Date(), "YYMMDD") +
                      "-" +
                      row.seq
                  );
                  LODOP.ADD_PRINT_TEXT(
                    "40mm",
                    "20mm",
                    "150mm",
                    "20mm",
                    row.customer + "-" + row.destination
                  );
                  LODOP.ADD_PRINT_TEXT(
                    "60mm",
                    "20mm",
                    "150mm",
                    "20mm",
                    row.number + "-" + (i + 1)
                  );
                  LODOP.NEWPAGE();
                });
              LODOP.PREVIEW();
            }
          },
          config: {
            title: this.$tz("过港标,打印"),
            modalBind: {
              width: 500
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {}
          },
          footer: {
            ok: {
              name: this.$tz("打印")
            }
          },
          grid: [
            { customer: 24 },
            { destination: 24 },
            { seq: 24 },
            { number: 24 }
          ],
          fields: [
            {
              name: () => this.$tz("客户"),
              key: "customer",
              component: "Input",
              placeholder: () => this.$tz("客户")
            },
            {
              name: () => this.$tz("机场代号"),
              key: "seq",
              component: "Input",
              placeholder: () => this.$tz("机场代号")
            },
            {
              name: () => this.$tz("目的地"),
              key: "destination",
              component: "Input",
              placeholder: () => this.$tz("目的地")
            },
            {
              name: () => this.$tz("件数"),
              key: "number",
              component: "Input",
              placeholder: () => this.$tz("件数")
            }
          ]
        },
        remarks: {
          type: "add",
          methods: {
            ok({ row, close }) {
              let data = this.handleFilterData();
              this.$page
                .handleRequestMethods("batchRemarks", data, true, true)
                .then(res => {
                  this.$page.getList();
                  close();
                });
            }
          },
          config: {
            title: this.$tz("批量,备注"),
            modalBind: {
              width: 500
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              airway_number: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur"
                }
              ]
            }
          },
          grid: [{ airway_number: 24 }, { remarks: 24 }],
          fields: [
            {
              key: "airway_number",
              name: () => this.$tz("订单号"),
              placeholder() {
                return this.$tz("订单号");
              },
              component: "Input",
              bind: {
                type: "textarea",
                autosize: { minRows: 4, maxRows: 6 }
              }
            },
            {
              key: "remarks",
              name: () => this.$tz("备注"),
              placeholder() {
                return this.$tz("备注");
              },
              component: "Input",
              bind: {
                type: "textarea",
                autosize: { minRows: 3, maxRows: 6 }
              }
            }
          ]
        },
        print: {
          type: "add",
          methods: {
            ok({ row, close }) {
              let data = this.handleFilterData({ id: row.id });
              this.$page
                .handleRequestMethods("createTransport", data, true, true)
                .then(res => {
                  let LODOP = getLodop(this);
                  LODOP.PRINT_INIT("打印任务名"); //首先一个初始化语句
                  LODOP.SET_PRINT_PAGESIZE(1, "100mm", "100mm", ""); //规定纸张大小；使用A4纸
                  LODOP.SET_PRINT_STYLE("Alignment", 2);
                  LODOP.SET_PRINT_STYLE("FontSize", 20);
                  Array.from({ length: data.number }, (_, i) => {
                    LODOP.SET_PRINT_STYLE("Alignment", 2);
                    LODOP.ADD_PRINT_BARCODE(
                      "15mm",
                      "10mm",
                      "80mm",
                      "20mm",
                      "128Auto",
                      res.payload
                    );
                    LODOP.SET_PRINT_STYLE("Alignment", 3);
                    LODOP.SET_PRINT_STYLE("FontSize", 30);
                    LODOP.ADD_PRINT_TEXT(
                      "45mm",
                      "10mm",
                      "30mm",
                      "10mm",
                      data.from_country
                    );
                    LODOP.ADD_PRINT_LINE("50mm", "45mm", "50mm", "55mm", 0, 1);
                    LODOP.SET_PRINT_STYLE("Alignment", 1);
                    LODOP.ADD_PRINT_TEXT(
                      "45mm",
                      "60mm",
                      "30mm",
                      "10mm",
                      data.to_country
                    );
                    LODOP.SET_PRINT_STYLE("Alignment", 2);
                    LODOP.SET_PRINT_STYLE("FontSize", 50);
                    LODOP.ADD_PRINT_TEXT(
                      "60mm",
                      "10mm",
                      "80mm",
                      "10mm",
                      data.number + "-" + (i + 1)
                    );
                    LODOP.SET_PRINT_STYLE("FontSize", 20);
                    LODOP.ADD_PRINT_TEXT(
                      "85mm",
                      "10mm",
                      "80mm",
                      "10mm",
                      `DATE:` + this.$page.format.zoneDate(new Date())
                    );
                    if (i !== this.selectAll.length - 1) {
                      LODOP.NEWPAGE();
                    }
                  });
                  LODOP.PREVIEW(); //打印预览
                });
            }
          },
          config: {
            title: this.$tz("打印,转运单"),
            modalBind: {
              width: 30
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              from_country: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur"
                }
              ],
              to_country: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur"
                }
              ],
              number: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                  type: "number"
                }
              ]
            }
          },
          grid: [{ from_country: 24 }, { to_country: 24 }, { number: 24 }],
          fields: [
            {
              name: this.$tz("起运国"),
              key: "from_country",
              component: "Select",
              placeholder: () => this.$tz("起运国"),
              options: [],
              optionsFn: "formCountry",
              optionsKey: "",
              default: ""
            },
            {
              name: this.$tz("目的国"),
              key: "to_country",
              component: "Select",
              placeholder: () => this.$tz(""),
              options: [],
              optionsFn: "toCountry",
              optionsKey: "",
              default: ""
            },
            {
              name: this.$tz("袋子总数"),
              key: "number",
              component: "InputNumber",
              default: 0,
              bind: {
                border: true,
                min: 0,
                step: 0.01,
                style: "width:100%"
              }
            }
          ]
        },
        update: {
          methods: {
            ok({ row, close }) {
              let data = JSON.parse(JSON.stringify(row));
              data["type"] = 1;
              this.$page
                .handleRequestMethods("updateOrderInfo", data, true)
                .then(e => {
                  this.$page.getList();
                  this.close();
                });
            }
          },
          footer: {
            ok: {},
            cancel: {}
          },
          config: {
            modalBind: {
              width: 540
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 20,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {}
          },
          grid: [
            {
              weight: 24
            },
            {
              volume: 24
            },
            {
              liquid_num: 24
            },

            {
              charged_num: 24
            },
            {
              percents: 24
            },
            {
              charging_weight: 24
            },
            { hk_agent: 24 },
            { lower_port: 24 }
          ],
          fields: [
            {
              name: () => this.$t("invoiceWeight"),
              key: "weight",
              component: "InputNumber",
              bind: {
                style: {
                  width: "100%"
                },
                min: 0
              },
              placeholder() {
                return this.$t("enter") + this.$t("invoiceWeight");
              },
              default: 0
            },
            // {
            //   name: () => this.$t("invoicePCS"),
            //   key: "quantity",
            //   component: "InputNumber",
            //   bind: {
            //     style: {
            //       width: "100%"
            //     },
            //     min: 0
            //   },
            //   placeholder() {
            //     return this.$t("enter") + this.$t("invoicePCS");
            //   },
            //   default: 0
            // },
            {
              name: () => this.$t("skuVolume"),
              key: "volume",
              component: "Input",
              bind: {
                style: {
                  width: "100%"
                },
                min: 0
              },
              placeholder() {
                return this.$t("enter") + this.$t("skuVolume");
              },
              default: "",
              paste: true
            },
            {
              name: () => this.$t("liquidPCS"),
              key: "liquid_num",
              component: "InputNumber",
              bind: {
                style: {
                  width: "100%"
                },
                min: 0
              },
              placeholder() {
                return this.$t("enter") + this.$t("liquidPCS");
              },
              default: 0
            },

            {
              name: () => this.$t("ElectricityPCS"),
              key: "charged_num",
              component: "InputNumber",
              bind: {
                style: {
                  width: "100%"
                },
                min: 0
              },
              placeholder() {
                return this.$t("enter") + this.$t("ElectricityPCS");
              },
              default: 0
            },
            {
              name: () => this.$t("percents"),
              key: "percents",
              component: "InputNumber",
              bind: {
                style: {
                  width: "100%"
                },
                min: 0
              },
              placeholder() {
                return this.$t("enter") + this.$t("percents");
              },
              default: 0
            },
            {
              name: () => this.$t("Billing") + this.$t("invoiceWeight"),
              key: "charging_weight",
              component: "InputNumber",
              bind: {
                style: {
                  width: "100%"
                },
                min: 0
              },
              placeholder() {
                return (
                  this.$t("enter") +
                  this.$t("Billing") +
                  this.$t("invoiceWeight")
                );
              },
              default: 0
            },
            {
              key: "hk_agent",
              name: () => this.$t("HKagency"),
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("HKagency");
              },
              options: this.hkAgentList
            },
            {
              key: "lower_port",
              name: () => this.$t("delivery_method"),
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("delivery_method");
              },
              options: []
            }
          ]
        },
        settime: {
          type: "add",
          methods: {
            ok({ row, close }) {
              this.$page
                .handleRequestMethods("boundTime", row, true)
                .then(e => {
                  this.$page.getList();
                  close();
                });
            }
          },
          footer: {
            ok: {},
            cancel: {}
          },
          config: {
            modalBind: {
              width: 400
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 13,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              time: [
                {
                  required: true,
                  message: "Please select the date and Time",
                  trigger: "change",
                  type: "date"
                }
              ]
            }
          },
          grid: [{ time: 24 }],
          fields: [
            {
              key: "time",
              name: () => this.$t("select") + this.$t("time"),
              component: "DatePicker",
              placeholder() {
                return this.$t("select") + this.$t("start") + this.$t("time");
              },
              disabled({ row }) {
                return row.disabled;
              },
              bind: {
                type: "datetime",
                options: {
                  disabledDate(time) {
                    console.log(time);
                    return time ? time.getTime() > Date.now() : true;
                  }
                },
                clearable: false
              }
            }
          ]
        },
        track: {
          methods: {
            ok({ row, close }) {
              this.$page.handleRequestMethods("addTrace", row, true).then(e => {
                this.$page.getList();
                this.close();
              });
            }
          },
          footer: {
            ok: {},
            cancel: {}
          },
          config: {
            modalBind: {
              width: 540
            },
            formBind: {
              labelWidth: 150
            },
            rowBind: {
              gutter: 13,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              time: [
                {
                  required: true,
                  message: "Please select the date and Time",
                  trigger: "change",
                  type: "date"
                }
              ],
              status_code: [
                {
                  required: true,
                  message: "Please select the track",
                  trigger: "change",
                  type: "number"
                }
              ]
            }
          },
          grid: [{ time: 24 }, { status_code: 24 }],
          fields: [
            {
              key: "time",
              name: () => this.$t("select") + this.$t("time"),
              component: "DatePicker",
              placeholder() {
                return this.$t("select") + this.$t("start") + this.$t("time");
              },
              bind: {
                type: "datetime",
                options: {
                  disabledDate(time) {
                    return time.getTime() > Date.now();
                  }
                },
                clearable: false
              }
            },
            {
              key: "status_code",
              name: () => this.$t("tracker_description"),
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("tracker_description");
              },
              options: trackList,
              config: {
                label({ row, field }) {
                  return this.$t(row.label);
                }
              }
            }
          ]
        },
        operate: {
          methods: {
            ok({ row, close }) {
              this.$page
                .handleRequestMethods("handlePacking", row, true)
                .then(e => {
                  this.$page.getList();
                  this.close();
                });
            }
          },
          footer: {
            ok: {},
            cancel: {}
          },
          config: {
            modalBind: {
              width: 540
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 20,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              package: [
                {
                  required: true,
                  message: "Please enter the package",
                  trigger: "blur"
                }
              ],
              type: [
                {
                  required: true,
                  message: "Please select the Type",
                  trigger: "change"
                }
              ]
            }
          },
          grid: [
            {
              package: 24
            },
            {
              type: 24
            }
          ],
          fields: [
            {
              name: () => this.$t("bagCode"),
              key: "package",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("bagCode");
              },
              bind: {
                type: "textarea",
                rows: 4
              }
            },
            {
              name: () => this.$t("type"),
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("type");
              },
              key: "type",
              options: typeList,
              config: {
                label({ row, field }) {
                  return this.$t(row.label);
                }
              }
            }
          ]
        },
        show: {
          config: {
            listFn: "list",
            modalBind: {
              width: 1200
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            }
          },
          footer: {
            show: false
          },
          fields: [],
          table: {
            config: {
              align: "center",
              height: 600
            },
            fields: [
              {
                name: () => this.$t("order_number"),
                key: "airway_bill",
                align: "center",
                tooltip: true,
                width: 150,
                header: {
                  copy: true
                },
                copy: true
              },
              {
                name: () => this.$t("warehouse_t") + this.$t("Remarks"),
                key: "remarks",
                align: "center",
                tooltip: true,
                minWidth: 100
              },
              {
                name: () => this.$t("bagCode"),
                key: "package_number",
                align: "center",
                tooltip: true,
                minWidth: 100
              },
              {
                name: () => this.$t("length"),
                key: "length",
                align: "center",
                tooltip: true,
                minWidth: 100
              },
              {
                name: () => this.$t("width"),
                key: "width",
                align: "center",
                tooltip: true,
                minWidth: 100
              },
              {
                name: () => this.$t("height"),
                key: "height",
                align: "center",
                tooltip: true,
                minWidth: 100
              },
              {
                name: () => this.$t("createTime"),
                key: "create_time",
                align: "center",
                tooltip: true,
                minWidth: 100
              }
            ]
          }
        },
        setHkAgent: {
          methods: {
            ok({ row, close }) {
              row["type"] = 1;
              this.$page
                .handleRequestMethods("addZhongGang", row, true)
                .then(e => {
                  this.$page.getList();
                  this.close();
                });
            }
          },
          footer: {
            ok: {},
            cancel: {}
          },
          config: {
            title: () => this.$t("setting") + this.$t("HKagency"),
            modalBind: {
              width: 540
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 13,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              hk_agent: [
                {
                  required: true,
                  message: "Please select the track",
                  trigger: "change",
                  type: "number"
                }
              ]
            }
          },
          grid: [{ hk_agent: 24 }],
          fields: [
            {
              key: "hk_agent",
              name: () => this.$t("HKagency"),
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("HKagency");
              },
              options: this.hkAgentList
            }
          ]
        },
        operLog: {
          config: {
            listFn: "getLog",
            isNoPage: true,
            modalBind: {
              width: 600
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            buttons: {
              bind: {
                style: {
                  display: "flex",
                  "justify-content": "flex-end",
                  "align-items": "center"
                }
              }
            }
          },
          footer: {
            show: false
          },
          table: {
            config: {
              height: 500
            },
            fields: [
              {
                name: () => this.$t("type"),
                key: "type",
                methods: {
                  render: ({ value }) => {
                    return +value ? this.$t("inbound") : this.$t("out");
                  }
                }
              },
              {
                name: () => this.$t("operation") + this.$t("time"),
                key: "operator_time"
              },
              {
                name: () => this.$t("operate"),
                key: "operator_name"
              }
            ]
          }
        }
      },
      header: {
        searchs: [
          {
            key: "warehouseId",
            placeholder() {
              return this.$t("select") + this.$t("warehouseName");
            },
            component: "Select",
            options: []
          },
          {
            key: "operator",
            placeholder() {
              return this.$t("select") + this.$t("status_operator");
            },
            component: "Select",
            options: [],
            config: {
              label: "account",
              value: "id"
            }
          },
          {
            key: "timeType",
            placeholder() {
              return this.$t("select") + this.$t("date") + this.$t("type");
            },
            clearable: false,
            component: "Select",
            options: [],
            methods: {
              async list({ field, searchForm }) {
                let res = await this.$sel.getData("OMS_PACKING_DATE_SELECT");
                field.options = res;
                searchForm[field.key] = res[0].value;
                this.$forceUpdate();
              }
            }
          },
          {
            key: "startTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("start") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "datetime",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "175px"
              }
            },
            methods: {
              "on-change"({ searchForm }) {
                searchForm.startTime = searchForm.startTime
                  ? this.$page.format.timeFormat(searchForm.startTime)
                  : "";
              }
            }
          },
          {
            key: "endTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("end") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "datetime",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "175px"
              }
            },
            methods: {
              "on-change"({ searchForm }) {
                let time = this.$page.format.timeFormat(searchForm.endTime);
                if (time.slice(-8) === "00:00:00") {
                  time = time.split(" ")[0] + " " + "23:59:59";
                  searchForm["endTime"] = time;
                }
              }
            }
          },
          {
            key: "clearance_agent_id",
            placeholder() {
              return this.$tz("代理");
            },
            component: "Select",
            options: [],
            optionsFn: "getTransportAgent",
            optionsKey: ""
          },
          {
            key: "keywordsType",
            placeholder() {
              return this.$t("select") + this.$t("keywords_type");
            },
            clearable: false,
            component: "Select",
            options: [],
            methods: {
              async list({ field, searchForm }) {
                let res = await this.$sel.getData("OMS_PACKING_KEYWORDS");
                field.options = res;
                searchForm[field.key] = res[0].value;
                this.$forceUpdate();
              }
            }
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            bind: {
              type: "textarea",
              rows: 1
            },
            component: "Input"
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("export"),
              type: "export",
              btnBind: {
                type: "primary"
              },
              list: [
                {
                  name: () => this.$t("LibraryDay"),
                  type: "exportOutboundData",
                  fnName: "exportFun",
                  id: 541
                },
                {
                  name: () => this.$t("Customsinfo"),
                  type: "exportCustomsData",
                  fnName: "exportFun",
                  id: 540
                },
                {
                  name: () => this.$t("packingData"),
                  type: "exportPackingZip",
                  fnName: "exportFun",
                  id: 537
                },
                {
                  name: () => this.$t("ListData"),
                  type: "ListData",
                  fnName: "ListData",
                  disabled() {
                    return !this.selectAll.length;
                  }
                }
              ]
            },
            // {
            //   name: () => this.$tz("打印"),
            //   type: "print",
            //   bind: {
            //     type: 'primary'
            //   },
            //   fnName: "print",
            // }
            {
              name: () => this.$tz("批量,备注"),
              type: "remarks",
              fnName: "remarks",
              bind: {
                type: "primary"
              }
            },
            {
              name: () => this.$tz("过港标,打印"),
              type: "print2",
              fnName: "print2",
              bind: {
                type: "primary"
              }
            },
            {
              name: () => this.$tz("小带电标,打印"),
              type: "print3",
              fnName: "print3",
              bind: {
                type: "primary"
              }
            }
          ],
          methods: {
            print3() {
              this.getModal("print3").open(null, function() {
                this.setTitle(this.$tz("小带电标,打印"));
              });
            },
            print2() {
              this.getModal("print2").open();
            },
            remarks() {
              this.getModal("remarks").open(null, function() {
                this.setTitle(this.$tz("批量,备注"));
              });
            },
            print() {
              this.getModal("print").open(null, function() {
                this.setTitle(this.$tz("打印,转运单"));
              });
            },
            exportFun({ field, searchForm }) {
              let data = {
                startTime: searchForm.startTime,
                endTime: searchForm.endTime,
                timeType: searchForm.timeType,
                warehouseId: searchForm.warehouseId,
                operator: searchForm.operator,
                keywords: searchForm.keywords,
                packing_id: this.selectAll.map(item => item.id)
              };
              this.openLoading();
              this.handleRequestMethods(field.type, data, false, true).then(
                res => {
                  window.open(globalUrl + res.payload.url);
                }
              );
            },
            // 导出列表数据
            ListData() {
              // let fields = [
              //   {
              //     name: this.$t("packing_number"),
              //     key: "packing_number"
              //   },
              //   {
              //     name: this.$t("ShippingDate"),
              //     key: "outbound_time"
              //   },
              //   {
              //     name: this.$t("addUser"),
              //     key: "operator_name"
              //   },
              //   {
              //     name: this.$t("bagsNum"),
              //     key: "package_total"
              //   },
              //   {
              //     name: this.$t("skuVolume"),
              //     key: "volume_size"
              //   },
              //   {
              //     name: this.$t("CustomsClearer"),
              //     key: "clearance_agent_name"
              //   },
              //   {
              //     name: this.$t("orderNums"),
              //     key: "order_total"
              //   },
              //   {
              //     name: this.$t("actual_weight"),
              //     key: "order_weight"
              //   }
              // ];
              // this.openLoading();
              // this.handleRequestMethods(
              //   "exportPacking",
              //   {
              //     packing_id: this.selectAll.map(item => item.id)
              //   },
              //   false,
              //   true
              // ).then(res => {
              // this.exportExc({ data: res.payload, fields });
              // });
              this.exportExc();
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60,
          show: false,
          fixed: "left"
        },
        {
          name: () => this.$t("packing_number"),
          key: "packing_number",
          align: "left",
          minWidth: 150,
          fixed: "left",
          copy: true,
          header: {
            copy: true
          }
        },
        {
          name: () => this.$t("mawb"),
          key: "mawb",
          align: "left",
          minWidth: 150,
          copy: true,
          header: {
            copy: true
          }
        },
        {
          name: () => this.$t("percents"),
          key: "percents",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("Weight") + "(KG)",
          key: "weight",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("Volume") + "(CBM)",
          key: "volume",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("orderNums"),
          key: "quantity",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("liquidPCS"),
          key: "liquid_num",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("ElectricityPCS"),
          key: "charged_num",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("Billing Weight"),
          key: "charging_weight",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("bagsNum"),
          key: "package_total",
          align: "center",
          minWidth: 100
        },

        // {
        //   name: () => this.$t("ElectricityPCS"),
        //   key: "electric_count",
        //   align: "center",
        //   minWidth: 100
        // },
        {
          name: () => this.$t("warehouseName"),
          key: "warehouseTitle",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("target_airport"),
          key: "target_airport",
          align: "left",
          minWidth: 120
        },
        {
          name: () => this.$t("agentName"),
          key: "clearance_agent_name",
          align: "left",
          minWidth: 100
        },
        {
          name: () => this.$t("HKagency"),
          key: "hk_agent_txt",
          width: 130
          // render: (h, params) => {
          //   return h(
          //     "div",
          //     {
          //       style: {
          //         overflow: "hidden",
          //         "text-overflow": "ellipsis",
          //         "white-space": "nowrap",
          //         width: params.row.hk_agent.length > 6 ? "101%" : "100%"
          //       }
          //     },
          //     [
          //       h(
          //         !params.row.hk_agent ? "Button" : "span",
          //         {
          //           props: {
          //             type: "warning",
          //             size: "small"
          //           },
          //           on: {
          //             click: () => {
          //               if (!params.row.hk_agent) {
          //                 this.$refs["table"]
          //                   .getModal("setHkAgent")
          //                   .open({ id: params.row.id });
          //               }
          //             }
          //           }
          //         },
          //         params.row.hk_agent
          //           ? params.row.hk_agent
          //           : this.$t("setting") + this.$t("HKagency")
          //       )
          //     ]
          //   );
          // }
        },
        {
          name: () => this.$t("delivery_method"),
          key: "lower_port",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("status_operator"),
          key: "operator_name",
          align: "center",
          minWidth: 100,
          component: "a",
          methods: {
            click({ row }) {
              this.$page.getModal("operLog").open(null, function() {
                this.pageConfig.data["packing_number"] = row.packing_number;
                this.pageConfig.data["pageSize"] = 99999;
                this.setTitle(this.$t("operationLog"));
                console.log(this.pageConfig);
                this.getList();
              });
            }
          }
        },

        {
          name: () => this.$t("order_desc"),
          key: "remarks",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("createTime"),
          key: "create_time",
          align: "center",
          minWidth: 180
        },
        {
          name: () => this.$t("outboundTime"),
          key: "outbound_time",
          component: "Button",
          align: "center",
          minWidth: 180,
          bind: {
            type: "warning",
            size: "small"
          },
          disabled: ({ value }) => {
            return !this.$hasPermission(187);
          },
          methods: {
            render: ({ row }) => {
              return row.outbound_time ? row.outbound_time : "Make Outbound";
            },
            click({ row }) {
              this.$page.getModal("settime").open(
                {
                  id: row.id,
                  type: "out",
                  time: row.outbound_time || new Date(),
                  disabled: !!row.outbound_time
                },
                function() {
                  this.setTitle(this.$t("update") + this.$t("outboundTime"));
                  this.fields[0].name = this.$t("outboundTime");
                }
              );
            }
          }
        },
        {
          name: () => this.$t("toHKtime"),
          key: "inbound_time",
          component: "Button",
          align: "center",
          minWidth: 180,
          bind: {
            type: "warning",
            size: "small"
          },
          disabled: ({ row }) => {
            return row.outbound_time === "" || !this.$hasPermission(188);
          },
          methods: {
            render: ({ value }) => {
              return value ? value : "Make Outbound";
            },
            click({ row }) {
              this.$page
                .getModal("settime")
                .open({ id: row.id, type: "in", time: new Date() }, function() {
                  // this.setFormData(data);
                  this.setTitle(this.$t("update") + this.$t("toHKtime"));
                  this.fields[0].name = this.$t("toHKtime");
                });
            }
          }
        },
        {
          name: () => this.$tz("提货,时间"),
          key: "pickup_time",
          minWidth: 130
        },
        {
          type: "btns",
          width: 370,
          name: () => this.$t("operation"),
          fixed: "right",
          list: [
            {
              name: () => this.$t("update"),
              type: "update",
              fnName: "updateFun",
              bind: {
                type: "success"
              }
            },
            {
              name: () => this.$t("show"),
              type: "show",
              fnName: "showFun",
              id: 248,
              bind: {
                type: "primary"
              }
            },
            {
              name: () => this.$t("trackRecord"),
              type: "track",
              fnName: "trackFun",
              id: 189,
              bind: {
                type: "warning"
              }
            },
            {
              name: () => this.$t("operation"),
              type: "operate",
              fnName: "operateFun",
              // id:248,
              bind: {
                type: "success"
              }
            },
            {
              name: () => this.$tz("打印"),
              type: "print",
              fnName: "print",
              // id:248,
              bind: {
                type: "primary"
              },
              disabled: ({ row }) => row.transport_id == 0
            },
            {
              name: () => this.$t("操作记录"),
              type: "operationLog",
              fnName: "operationLog",
              bind: {
                type: "success"
              }
            },
          ],
          methods: {
            print({ row }) {
              this.handleRequestMethods(
                "createTransport",
                { transport_id: row.transport_id },
                true,
                true
              ).then(res => {
                let data = res.payload;
                let LODOP = getLodop(this);
                LODOP.PRINT_INIT("打印任务名"); //首先一个初始化语句
                LODOP.SET_PRINT_PAGESIZE(1, "100mm", "100mm", ""); //规定纸张大小；使用A4纸
                LODOP.SET_PRINT_STYLE("Alignment", 2);
                LODOP.SET_PRINT_STYLE("FontSize", 20);
                Array.from({ length: data.number }, (_, i) => {
                  LODOP.SET_PRINT_STYLE("Alignment", 2);
                  LODOP.ADD_PRINT_BARCODE(
                    "15mm",
                    "10mm",
                    "80mm",
                    "20mm",
                    "128Auto",
                    data.transport_number
                  );
                  LODOP.SET_PRINT_STYLE("Alignment", 3);
                  LODOP.SET_PRINT_STYLE("FontSize", 30);
                  LODOP.ADD_PRINT_TEXT(
                    "45mm",
                    "10mm",
                    "30mm",
                    "10mm",
                    data.from_country
                  );
                  LODOP.ADD_PRINT_LINE("50mm", "45mm", "50mm", "55mm", 0, 1);
                  LODOP.SET_PRINT_STYLE("Alignment", 1);
                  LODOP.ADD_PRINT_TEXT(
                    "45mm",
                    "60mm",
                    "30mm",
                    "10mm",
                    data.to_country
                  );
                  LODOP.SET_PRINT_STYLE("Alignment", 2);
                  LODOP.SET_PRINT_STYLE("FontSize", 50);
                  LODOP.ADD_PRINT_TEXT(
                    "60mm",
                    "10mm",
                    "80mm",
                    "10mm",
                    data.number + "-" + (i + 1)
                  );
                  LODOP.SET_PRINT_STYLE("FontSize", 20);
                  LODOP.ADD_PRINT_TEXT(
                    "85mm",
                    "10mm",
                    "80mm",
                    "10mm",
                    `DATE:` + this.format.zoneDate(new Date())
                  );
                  if (i !== this.selectAll.length - 1) {
                    LODOP.NEWPAGE();
                  }
                });
                LODOP.PREVIEW(); //打印预览
              });
            },
            updateFun({ row }) {
              if (row.volume <= 0) {
                row.volume = "";
              }
              this.getModal("update").open(row, function() {
                this.setTitle(this.$t("update") + row.packing_number);
              });
            },
            operationLog({ row }) {
              fetchOperationLog(row.mawb || row.packing_number).then(res => {

                this.getModal("operationModal").open(row, function() {
                  this.list = res.data.payload
                })
              })
            },
            async showFun({ row }) {
              try {
                let res = await this.handleRequestMethods("postCnbNum", {
                  packing_number: [row.packing_number]
                });
                console.log(res, this.getModal("show"));
                this.getModal("show").open({ data: res.payload.rows }, () => {
                  this.getModal("show").setTitle(
                    this.$t("show") + row.packing_number
                  );
                  this.getModal("show").table.fields.forEach(item => {
                    if (item.key === "airway_bill") {
                      item.name = () => {
                        return (
                          this.$t("order_number") +
                          `(${res.payload.airwayTotal})`
                        );
                      };
                    }
                    if (item.key == "package_number") {
                      item.name = () => {
                        return (
                          this.$t("bagCode") + `(${res.payload.packageTotal})`
                        );
                      };
                    }
                  });
                  // this.getModal("show").table.fields[0].name = () => {
                  //   return (
                  //     this.$t("order_number") + `(${res.payload.airwayTotal})`
                  //   );
                  // };
                  // this.getModal("show").table.fields[1].name = () => {
                  //   return this.$t("bagCode") + `(${res.payload.packageTotal})`;
                  // };
                  this.getModal("show").list = res.payload.rows;
                });
              } catch (e) {
                //TODO handle the exception
                console.log(e);
              }
            },
            trackFun({ row }) {
              this.getModal("track").open(
                { time: new Date(), status_code: "", id: row.id },
                function() {
                  this.setTitle(this.$t("trackRecord"));
                }
              );
            },
            operateFun({ row }) {
              this.getModal("operate").open({ id: row.id }, function() {
                this.setTitle(this.$t("operation"));
              });
            }
          }
        }
      ]
    };
  }
};
</script>
<style type="text/css">
/* @page{
    size: 7cm 8cm;
  } */
</style>
<style lang="scss" scoped></style>
